<template>
    <div>
        <input type="hidden" :name="name" :value="editorContent">
        <ckeditor :required="required" class="editor-border" :editor="editor" :config="editorConfig" v-model="editorContent"/>
    </div>
</template>

<script>
import CustomEditor from "../includes/ck-editor/ck-editor-custom";
import UploadAdapter from "./UploadAdapter";

export default {
    name: "CKEditorBox",
    props: ['name', 'value', 'required'],
    data() {
        return {
            editorContent: this.value || '',
            editor: CustomEditor,
            editorConfig: {
                extraPlugins: [this.uploader],
                language: document.documentElement.lang,
                link: {
                    addTargetToExternalLinks: true,
                    defaultProtocol: 'http://',
                },
                toolbar: {
                },
               mediaEmbed: {
                    previewsInData: true
                }
            }
        }
    },
    methods: {
        uploader(editor) {
            editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                return new UploadAdapter( loader );
            };
        },
    }
}
</script>

<style>
    .media {
        display: block;
    }
    .image {
        margin: auto !important;
    }
    .image img{
        width: 100%;
    }
</style>
